export default __webpack_public_path__ + "static/media/Minions.c627fdc7.png";